<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 md3 class="pr-1">
        <v-select
          v-model="filter.sortBy"
          :items="sortByOptions"
          outline
          hide-details
          single-line
          @change="handleChangeSortBy"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 class="pr-1">
        <DatepickerCustomDialog
          v-if="filter.sortBy"
          v-model="filter.startDate"
          @change="handleSelectStartDate"
        >
          <template #default="{ computedDate }">
            <v-text-field
              class="default-input"
              outline
              name="startDate"
              :placeholder="$t('Start date')"
              readonly
              :value="computedDate"
              hide-details
              single-line
              clearable
              @click:clear="filter.startDate = undefined"
            ></v-text-field>
          </template>
        </DatepickerCustomDialog>
      </v-flex>
      <v-flex xs12 sm6 md3 class="pr-1">
        <DatepickerCustomDialog
          v-if="filter.sortBy"
          v-model="filter.endDate"
          @change="handleSelectEndDate"
        >
          <template #default="{ computedDate }">
            <v-text-field
              class="default-input"
              outline
              name="endDate"
              :placeholder="$t('End date')"
              readonly
              :value="computedDate"
              hide-details
              single-line
              clearable
              @click:clear="filter.endDate = undefined"
            ></v-text-field>
          </template>
        </DatepickerCustomDialog>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-text-field
          v-model="filter.search"
          class="default-input"
          outline
          name="search"
          hide-details
          single-line
          placeholder="Search"
          clearable
          append-icon="search"
          style="max-width: 300px"
          dense
          :loading="loading"
          @click:clear="filter.search = ''"
          @keydown.enter="onSearch"
          @input="onSearch"
        />
      </v-flex>
    </v-layout>

    <v-btn depressed color="primary" @click="showAddBundle = true">{{ $t('Add') }}</v-btn>

    <div v-if="loading" class="text-xs-center py-3">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <template v-else-if="data && data.length > 0">
      <Pagination :limit="limit" :total="total" @onChange="handleChangePage">
        <template v-for="bundle in data">
          <div
            :key="bundle.id"
            class="z-border-red mb-2"
            :style="{
              'border-left': bundle.is_active ? `5px solid #a0e83d` : `5px solid red`
            }"
          >
            <div class="pa-1">
              <v-layout>
                <v-flex shrink class="pt-2 pl-2">
                  <toggle-button
                    :value="bundle.status"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    @change="handleChangeBundleStatus(bundle)"
                  />
                </v-flex>
                <v-flex class="pa-2">
                  <strong>ชื่อโปรโมชั่น: {{ bundle.name }}</strong>
                  <div>
                    ประเภทโปรโมชั่น: ซื้อ {{ bundle.quantity_condition }} ชิ้น / ลด
                    {{ bundle.discount }} บาท
                  </div>
                  <v-chip
                    v-if="bundle.effective_date"
                    color="success"
                    small
                    disabled
                    class="white--text"
                  >
                    {{ bundle.effective_date | DateFormat('DD/MM/YYYY HH:mm') }}
                  </v-chip>
                  <v-chip v-if="bundle.end_date" color="success" small disabled class="white--text">
                    {{ bundle.end_date | DateFormat('DD/MM/YYYY HH:mm') }}
                  </v-chip>
                </v-flex>
                <v-flex shrink>
                  <v-btn outline color="primary" icon small @click="handleEditBundle(bundle)">
                    <v-icon small>edit</v-icon>
                  </v-btn>
                  <!-- <v-btn outline color="primary" icon small @click="handleCopyBundle">
                    <v-icon small>file_copy</v-icon>
                  </v-btn> -->
                  <v-btn outline color="primary" icon small @click="handleDeleteBundle(bundle)">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
            <v-divider />

            <v-data-table
              v-if="showBundleProduct == bundle.id"
              :headers="bundleProductHeaders"
              :items="bundle.products"
              class="elevation-0"
              :pagination.sync="pagination"
              :loading="loading"
              hide-actions
            >
              <template #items="props">
                <tr>
                  <td>
                    <v-layout>
                      <v-flex shrink class="pa-2">{{ props.index + 1 }}</v-flex>
                      <v-flex shrink class="pa-1">
                        <img
                          :src="
                            props.item.photourl.length
                              ? props.item.photourl[0]
                              : '/static/img/assets/_global/default-photo.png'
                          "
                          :alt="`bundle_${props.index + 1}`"
                          style="width: 50px"
                        />
                      </v-flex>
                      <v-flex class="pa-2">{{ props.item.name }}</v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-center">{{ props.item.price || 0 }}</td>
                  <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
                </tr>
              </template>
            </v-data-table>

            <v-btn
              small
              block
              flat
              class="my-0"
              @click="showBundleProduct = showBundleProduct == bundle.id ? null : bundle.id"
            >
              {{ $t(showBundleProduct == bundle.id ? 'Show less products' : 'Show more products') }}
              ({{ bundle.products.length }})
              <v-icon>{{ showBundleProduct == bundle.id ? 'expand_less' : 'expand_more' }}</v-icon>
            </v-btn>
          </div>
        </template>
      </Pagination>
    </template>
    <div v-else class="text-xs-center py-3">
      {{ $t('No data') }}
    </div>

    <template v-if="showAddBundle">
      <ManageBundle
        v-model="showAddBundle"
        type="add"
        @handleSaveManageBundle="handleManageBundle"
      />
    </template>
    <template v-if="showEditBundle">
      <ManageBundle
        v-model="showEditBundle"
        type="edit"
        :bundle="currentBundle"
        @handleSaveManageBundle="handleManageBundle"
      />
    </template>
  </v-container>
</template>

<script>
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Pagination from '@/components/elements/Pagination2.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import ManageBundle from './ManageBundle'
import nestleApi from '@/api/nestle'
import { handleResponse, handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
export default {
  components: {
    DatepickerCustomDialog,
    Pagination,
    ToggleButton,
    ManageBundle
  },
  data() {
    return {
      loading: true,
      searchTimeout: null,
      data: [],
      limit: 10,
      total: 0,
      offset: 0,
      filter: {
        search: '',
        startDate: null,
        endDate: null,
        sortBy: 'Promotion date'
      },
      sortByOptions: [
        {
          text: 'Promotion date',
          value: 'Promotion date'
        },
        {
          text: 'Create date',
          value: 'Create date'
        }
      ],
      pagination: { rowsPerPage: -1 },
      bundleProductHeaders: [
        { text: 'รายการสินค้า', value: 'name' },
        { text: 'ราคา', value: 'price', align: 'center' },
        { text: 'จำนวนสินค้า', value: 'quantity', align: 'center' }
      ],
      showAddBundle: false,
      showEditBundle: false,
      currentBundle: null,
      showBundleProduct: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadCategory')
    const { result, total } = await this.getBundle()
    console.log(result)
    this.data = result
    this.total = total
    this.loading = false
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.offset = 0
          const { result, total } = await vm.getBundle()
          vm.data = result
          vm.total = total
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.searchTimeout = null
      }, 1000)
    },
    async getBundle() {
      try {
        const response = await nestleApi.getAllBundles({
          data: {
            search: this.filter.search || undefined,
            startDate: this.filter.startDate || undefined, // optional
            endDate: this.filter.endDate || undefined, // optional
            sortBy: this.filter.sortBy, // optional
            limit: this.limit,
            offset: this.offset,
            pageid: this.selectedBot.pageid
          }
        })

        await handleResponse(response)
        const bundles = response.data.product_bundle.map((bundle) => {
          const products = bundle.products.map((product) => {
            const photourl = product.photourl.split(';;')
            return {
              ...product,
              photourl
            }
          })
          return { ...bundle, products }
        })
        return {
          result: bundles,
          total: response.data.total_product_bundle
        }
      } catch (error) {
        handleApiError(error)
      }

      return {
        result: [],
        total: 0
      }
    },
    async handleManageBundle(payload) {
      await this.manageBundle(payload.data)
      if (payload.onComplete) {
        payload.onComplete()
        await this.handleFilterChange()
      }
    },
    async manageBundle(bundle) {
      try {
        const product_ids = bundle.products.map((product) => product.id)
        delete bundle.end_time
        delete bundle.effective_time
        delete bundle.products
        const data = {
          ...bundle,
          product_ids: product_ids,
          pageid: this.selectedBot.pageid
        }
        if (bundle.id) {
          // edit
          const response = await nestleApi.putProductBundle({
            data
          })
          handleResponse(response)
          return true
        } else {
          // add
          const response = await nestleApi.postProductBundle({
            data
          })
          handleResponse(response)
          return true
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    async handleFilterChange() {
      this.loading = true
      const { result, total } = await this.getBundle()
      this.data = result
      this.total = total
      this.loading = false
    },
    async handleChangePage(val) {
      const { offset } = val
      this.offset = offset
      await this.handleFilterChange()
    },
    async handleChangeSortBy() {
      await this.handleFilterChange()
    },
    async handleSelectStartDate() {
      await this.handleFilterChange()
    },
    async handleSelectEndDate() {
      await this.handleFilterChange()
    },
    async handleEditBundle(item) {
      this.currentBundle = item
      await this.$nextTick()
      this.showEditBundle = true
    },
    async handleCopyBundle(item) {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to copy this?'),
        type: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.loading = true
        const bundle = { ...item, id: undefined }
        if (await this.manageBundle(bundle)) {
          // call api to copy
          await this.handleFilterChange()
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
        this.loading = false
      }
    },
    async handleDeleteBundle(bundle) {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        // call api to delete
        await nestleApi.deleteProductBundle({
          data: {
            id: bundle.id,
            pageid: this.selectedBot.pageid
          }
        })
        await this.handleFilterChange()
        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    },
    async handleChangeBundleStatus(bundle) {
      bundle.status = !bundle.status
      await nestleApi.putProductBundleStatus({
        data: {
          pageid: this.selectedBot.pageid,
          id: bundle.id,
          status: bundle.status
        }
      })
      await this.handleFilterChange()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Bundles/Bundles.vue